import { render, staticRenderFns } from "./toggle-content.vue?vue&type=template&id=8c84abcc&scoped=true"
import script from "./toggle-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./toggle-content.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./toggle-content.vue?vue&type=style&index=0&id=8c84abcc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c84abcc",
  null
  
)

export default component.exports